import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppConfig } from '../../../config';
import { EntityFile } from '../../../model/api/common/entity-file';
import { Param } from '../../../model/common/param';

import { GenericHttpService } from '../generic.http.service';
// import { AuthHttp } from 'angular2-jwt';

@Injectable()
export class EntityFileHttpService extends GenericHttpService<EntityFile, number> {
    constructor(public http: HttpClient) {
        super(http, "", "entityfiles");
    }

    public download(entityFileId: number) {
        let url = AppConfig.urlPrefix + this.url + '/download' + `/${entityFileId}`;

        // return this.http.get(url, { responseType: ResponseContentType.ArrayBuffer })
        //                 .map(res => res.arrayBuffer());
        return this.http.get(url, { responseType: 'blob' }).pipe(
                        map(res => res));
    }

    public upload(fileToUpload: any, entityId: number, entityTypeCode: string, info: string) {
        let input = new FormData();
        input.append("file", fileToUpload);
        input.append("entityId", entityId.toString());
        input.append("entityTypeCode", entityTypeCode);
        input.append("info", info);

        return this.http
            .post(AppConfig.urlPrefix + this.url + '/upload', input);
    }

    // public getByEntity(entityTypeCode: string, entityId: number): Observable<EntityFile> {
    //     let params: Array<Param> = new Array<Param>();

    //     params.push(new Param('entityTypeCode', entityTypeCode));
    //     params.push(new Param('entityId', entityId.toString()));

    //     return this.get(null, null, '', '', params, null).map((data: any) => {
    //             //return data != null ? data.json() : null;
    //             return data;
    //         });
    // }

    public getByEntity(entityTypeCode: string, entityId: number): Observable<Array<EntityFile>> {
        let params: Array<Param> = new Array<Param>();

        params.push(new Param('entityTypeCode', entityTypeCode));
        params.push(new Param('entityId', entityId.toString()));

        return this.get(null, null, null, null, params, null).pipe(map((data: any) => {
                return data;
            }));
    }

    public deletePhoto(id: number): Observable<any> {
        return this.http.delete(AppConfig.urlPrefix + this.url + '/deletePhoto' + `/${id}`);
    }
}